<template>
  <article class="car-search-content">

    <!-- 이미지 모달 -->
    <div v-if="showImageModal" class="image-modal-overlay" @click="showImageModal = false">
      <div class="image-modal-wrapper" @click.stop>
        <div class="image-modal-header mt-10">
          <button class="modal-delete-btn ms-10" @click="onRemoveImage(selectedImageIndex)">삭제</button>
          <button class="modal-close-btn me-10" @click="showImageModal = false">닫기</button>
        </div>
        <img :src="getImageUrl(car.black.pictures[selectedImageIndex])" class="image-modal-content"  alt=""/>
      </div>
    </div>

    <!-- 블랙 등록 모달 -->
    <div
      v-if="showBlackRegisterModal"
      class="modal-overlay"
      @click="showBlackRegisterModal = false"
    >
      <div class="modal-box" @click.stop>
        <p class="modal-message">정말 블랙 등록 하시겠습니까?</p>
        <div class="modal-buttons">
          <button class="modal-cancel-btn" @click="showBlackRegisterModal = false">취소</button>
          <button class="modal-confirm-btn" @click="onClickRegisterBlack">등록</button>
        </div>
      </div>
    </div>

    <!-- 블랙 해제 모달 -->
    <div
      v-if="showBlackReleaseModal"
      class="modal-overlay"
      @click="showBlackReleaseModal = false"
    >
      <div class="modal-box" @click.stop>
        <p class="modal-message">정말 블랙 해제 하시겠습니까?</p>
        <div class="modal-buttons">
          <button class="modal-cancel-btn" @click="showBlackReleaseModal = false">취소</button>
          <button class="modal-confirm-btn" @click="onClickReleaseBlack">해제</button>
        </div>
      </div>
    </div>

    <div v-if="isNeedLogin" class="login-container">
      <v-form
        ref="form"
        class="login-form"
      >
        <h1 class="login__title form__title">임서 차량 정보 시스템</h1>
        <v-text-field
          v-model="email"
          label="아이디를 입력하세요."
          required
        ></v-text-field>

        <v-text-field
          v-model="password"
          :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show4 ? 'text' : 'password'"
          name="input-10-2"
          label="비밀번호를 입력하세요."
          @click:append="show4 = !show4"
        ></v-text-field>

        <v-btn
          block
          :disabled="!(email && password).trim()"
          color="primary"
          class="mt-4"
          @click="onSubmit"
          x-large
          depressed
          tile
        >
          로그인
        </v-btn>
      </v-form>
    </div>

    <div class="car-ui-wrapper" v-if="!isNeedLogin">
      <div class="car-search-header" v-if="!isNeedLogin">
        <div class="header-title">임서 차량 정보 시스템</div>
        <div class="header-icons">
          <v-icon @click="onRefresh" class="header-icon" color="white">mdi-refresh</v-icon>
          <v-icon @click="toggleTheme" class="header-icon" color="white">
            {{ isDarkTheme ? 'mdi-weather-night' : 'mdi-weather-sunny' }}
          </v-icon>
        </div>
      </div>
      <div v-if="!isNeedLogin" class="car-scrollable-content">
        <div class="car-info" v-if="searchCarNumber === ''">차량 번호를 입력해주세요</div>
        <div class="car-info" v-else-if="car != null && car.carNumber !== ''" style="">
          <div class="car-header">
            <div class="car-number-info">
              <div class="car-number">{{ car.carNumber }}</div>
              <div class="car-owner">
                <span class="name">{{ car.ownerName }}</span>
                <span class="phone">
                  <a :href="'tel:' + sanitizePhone(car.ownerPhone)" style="color: #627ef8">{{ formatPhoneNumber(car.ownerPhone) }}</a>
                </span>
              </div>
            </div>
            <div class="result-status-list">
              <div v-if="carStatus.normal" class="status-badge" style="background-color: #627ef8">일반</div>
              <div v-if="carStatus.black" class="status-badge" style="background-color: black">블랙</div>
              <div v-if="carStatus.basement" class="status-badge" style="background-color: orange">지하</div>
              <div v-if="carStatus.newbie" class="status-badge" style="background-color: green">새가족</div>
            </div>
          </div>
          <div style="padding: 0 8px 16px 8px">
            <div class="status-left">
              <!-- 지하이용 카드 -->
              <div v-if="carStatus.basement" class="status-card">
                <div class="card-title" style="color: #995500; cursor: pointer" @click="isBasementOpen = !isBasementOpen">
                  지하이용 대상자
                  <span style="float: right; color: #333333">{{ isBasementOpen ? '▲' : '▼' }}</span>
                </div>
                <div v-show="isBasementOpen">
                  <div class="status-text">지하이용 시작: {{ car.basement.startDate || '-' }}</div>
                  <div class="status-text">지하이용 종료: {{ car.basement.endDate || '-' }}</div>
                  <div v-if="car.basement.reason" class="status-text mt-4" style="font-size: 15px; color: #1a212f">{{ car.basement.reason || '비고 없음' }}</div>
                </div>
              </div>
              <!-- 새가족 카드 -->
              <div v-if="carStatus.newbie" class="status-card">
                <div class="card-title" style="color: #009955; cursor: pointer" @click="isNewbieOpen = !isNewbieOpen">
                  새가족
                  <span style="float: right; color: #333333">{{ isNewbieOpen ? '▲' : '▼' }}</span>
                </div>
                <div v-show="isNewbieOpen">
                  <div class="status-text">새가족 시작: {{ car.newbie.startDate || '-' }}</div>
                  <div class="status-text">새가족 종료: {{ car.newbie.endDate || '-' }}</div>
                  <div v-if="car.newbie.reason" class="status-text mt-4" style="font-size: 15px; color: #1a212f">{{ car.newbie.reason || '' }}</div>
                </div>
              </div>
              <div v-if="carStatus.black" class="status-card">
                <div class="card-title" style="color: #777777; cursor: pointer" @click="isBlackOpen = !isBlackOpen">
                  블랙
                  <span style="float: right; color: #333333">{{ isBlackOpen ? '▲' : '▼' }}</span>
                </div>
                <div v-show="isBlackOpen">
                  <div class="black-status-row">
                    <div class="black-status-text">
                      <div class="status-text">블랙 등록: {{ car.black.startDate || '-' }}</div>
                      <div class="status-text">블랙 종료: {{ car.black.endDate || '-' }}</div>
                    </div>
                    <div class="black-status-buttons">
                      <v-btn color="grey" style="color: #ffffff" @click="showBlackReleaseModal = true">블랙 해제</v-btn>
                    </div>
                  </div>
                  <div class="photo-wrapper mt-4">
                    <div class="photo-list">
                      <div v-for="(img, i) in car.black.pictures" :key="i" class="photo-item">
                        <img
                          :src="getImageUrl(img)"
                          class="photo-thumb"
                          @click="onClickImage(i)"
                         alt=""/>
                      </div>
                      <button
                        v-if="(car.black.pictures.length || 0) < 5"
                        class="photo-add"
                        @click="onAddPhoto"
                      >+</button>
                    </div>
                  </div>
                  <div v-if="car.black.reason" class="status-text mt-4" style="font-size: 15px">{{ car.black.reason || '비고 없음' }}</div>
                </div>
              </div>
              <div v-if="!carStatus.black" class="status-card">
                <div class="black-status-row">
                  <div class="card-title" style="color: #777777">블랙</div>
                  <v-btn style="color: #ffffff" color="grey" @click="showBlackRegisterModal = true">블랙 등록</v-btn>
                </div>
              </div>
            </div>
          </div>
          <!-- 관계 카드 -->
          <div style="padding: 0 8px 16px 8px">
            <div v-if="car.relationships && car.relationships.length > 0" class="status-card">
              <div class="card-title" style="cursor: pointer; color: #777777" @click="isRelationOpen = !isRelationOpen">
                관계 (가족 등)
                <span style="float: right; color: #333333">{{ isRelationOpen ? '▲' : '▼' }}</span>
              </div>
              <div v-show="isRelationOpen">
                <div
                  v-for="(rel, i) in car.relationships"
                  :key="i"
                  class="car-relation"
                  style="margin-bottom: 8px"
                >
                  <span class="name">{{ rel.name }}</span>
                  <span class="phone">
                    <a :href="'tel:' + sanitizePhone(rel.number)" style="color: #627ef8">{{ formatPhoneNumber(rel.number) }}</a>
                  </span>
                  <span class="relation">{{ rel.relationship }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 비고 카드 -->
          <div style="padding: 0 8px 8px 8px">
            <div class="status-card">
              <div class="card-title" style="color: #777777; display: flex; justify-content: space-between; align-items: center;">
                <span>비고</span>
                <div>
                  <template v-if="!isEditingDetail">
                    <v-btn color="grey" style="color: white" @click="startEditDetail">수정</v-btn>
                  </template>
                  <template v-else>
                    <v-btn color="grey" style="color: white; margin-right: 4px;" @click="cancelEditDetail">취소</v-btn>
                    <v-btn color="primary" style="color: white;" @click="saveDetail">완료</v-btn>
                  </template>
                </div>
              </div>
              <div class="status-text mt-2" style="font-size: 15px;">
                <template v-if="!isEditingDetail">
                  <div v-if="car.ownerDetail" class="mb-2" style="color: var(--text-color)">{{ car.ownerDetail }}</div>
                </template>
                <template v-else>
                  <v-textarea
                    v-model="editableDetail"
                    outlined
                    rows="3"
                    auto-grow
                    dense
                  ></v-textarea>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="showSearchResults === true" class="car-info">
          {{ searchCarNumber }} 번호의 차를 선택해주세요
        </div>
        <div v-else class="car-info">
          {{ searchCarNumber }} 번호의 차는 없습니다
        </div>
        <div v-if="showSearchResults" class="search-result-list">
          <div
            class="search-result-item"
            v-for="item in searchResults"
            :key="item.carNumber"
            @click="setCurrentCar(item)"
          >
            <div class="result-card">
              <div class="result-car-number">{{ item.carNumber }}</div>
              <div class="result-status-list">
                <div class="result-status" v-if="getStatus(item).black" style="background-color: black">블랙</div>
                <div class="result-status" v-if="getStatus(item).basement" style="background-color: orange">지하</div>
                <div class="result-status" v-if="getStatus(item).newbie" style="background-color: green">새가족</div>
                <div class="result-status" v-if="getStatus(item).normal" style="background-color: #627ef8">일반</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="car-input">
        <div v-if="inputText !== ''" class="input-display">{{ inputText }}</div>
        <div v-if="inputText === ''" class="input-display-empty">차번호 4자리를 입력해주세요</div>
        <div class="keypad">
          <div class="row" v-for="(row, i) in keypadRows" :key="i">
            <button style="background-color: var(--border-color-2)" v-for="key in row" :key="key" @click="onKeyPress(key)">{{ key }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 3) 실제 파일 선택용 input (숨겨져 있음) -->
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="onHandleImageFile"
    />
  </article>
</template>

<script>

import { car, image, user } from '@/api'
import eventBus from '@/utils/eventBus'
import sha256 from 'crypto-js/sha256'
import principal from '../utils/principal'

export default {
  name: 'Car',
  components: {
    // Carousel
  },
  data: () => ({
    isDarkTheme: false,
    isNeedLogin: true,
    email: '',
    password: '',
    show4: false,
    inputText: '',
    keypadRows: [
      ['1', '2', '3'],
      ['4', '5', '6'],
      ['7', '8', '9'],
      ['←', '0', 'X']
    ],
    searchCarNumber: '',
    searchResults: [], // 4자리 입력 결과 리스트
    showSearchResults: false, // 리스트 보여줄지 여부
    carStatus: {
      label: '일반',
      normal: true,
      basement: false,
      newbie: false,
      black: false,
      color: '--bg-color'
    },
    carList: null,
    car: {
      carNumber: '',
      ownerName: '',
      ownerPhone: '',
      ownerDetail: '',
      relationships: [
        // {
        //   name: '',
        //   number: '',
        //   relationship: ''
        // }
      ],
      createdDate: '',
      updatedDate: '',
      black: null,
      // {
      //   startDate: ''
      //   endDate: '',
      //   reason: '',
      //   pictures: [''],
      // }
      basement: null,
      // {
      //   startDate: ''
      //   endDate: '',
      //   reason: '',
      // }
      newbie: null
      // {
      //   startDate: ''
      //   endDate: '',
      //   reason: '',
      // }
    },
    selectedImage: null,
    showImageModal: false,
    showBlackRegisterModal: false,
    showBlackReleaseModal: false,
    selectedImageIndex: null,
    isBasementOpen: false,
    isNewbieOpen: false,
    isBlackOpen: false,
    isRelationOpen: false,
    isEditingDetail: false,
    editableDetail: ''
  }),
  created () {
    this.setNeedLogin()
    if (!this.isNeedLogin) {
      this.fetchList()
      this.setStatus()
    }
  },
  watch: {
    inputText (newText) {
      if (newText.length === 4) {
        this.findCarByPartialNumber(newText)
      }
    }
  },
  methods: {
    setNeedLogin () {
      this.isNeedLogin = !principal.getPrincipal()
    },
    setStatus () {
      if (this.isNeedLogin) return
      this.carStatus = this.getStatus(this.car)
    },
    onKeyPress (key) {
      if (key === '←') {
        this.inputText = this.inputText.slice(0, -1)
      } else if (key === 'X') {
        this.inputText = ''
      } else {
        this.inputText += key
      }
    },
    async onSubmit () {
      try {
        const { data } = await user.signIn(this.email, sha256(this.password).toString())
        principal.storePrincipal(data.token)
        this.setNeedLogin()
        await this.fetchList()
        this.setStatus()
      } catch (e) {
        if (e.response) {
          eventBus.$emit('alert', { active: true, text: e.response.data.message, type: 'error' })
        }
      }
    },
    async fetchList () {
      eventBus.$emit('showLoading')
      const { data } = await car.list_all()
      eventBus.$emit('hideLoading')
      this.carList = data

      const selectedCarNumber = this.car?.carNumber
      const foundCar = this.carList.find(item => item.carNumber === selectedCarNumber) || null
      if (foundCar) {
        this.car = JSON.parse(JSON.stringify(foundCar))
      } else {
        this.car = {
          carNumber: '',
          ownerName: '',
          ownerPhone: '',
          ownerDetail: '',
          relationships: [],
          createdDate: '',
          updatedDate: '',
          black: null,
          basement: null,
          newbie: null
        }
      }
      this.showSearchResults = false
      this.searchResults = []
    },
    findCarByPartialNumber (partialNumber) {
      if (!this.carList || !Array.isArray(this.carList)) {
        eventBus.$emit('alert', { active: true, text: '차 정보가 없습니다', type: 'error' })
        return
      }

      const results = this.carList.filter(car =>
        car.carNumber.includes(partialNumber)
      )

      this.searchCarNumber = partialNumber
      this.inputText = ''

      if (results.length === 1) {
        this.car = JSON.parse(JSON.stringify(results[0]))
        this.showSearchResults = false
        this.searchResults = []
        this.setStatus()
      } else if (results.length > 1) {
        this.searchResults = results
        this.showSearchResults = true
        this.car = { carNumber: '' }
      } else {
        this.car = { carNumber: '' }
        this.searchResults = []
        this.showSearchResults = false
      }
    },
    onRefresh () {
      this.fetchList()
      if (this.searchCarNumber.length === 4) {
        this.findCarByPartialNumber(this.searchCarNumber)
      }
    },
    toggleTheme () {
      this.isDarkTheme = !this.isDarkTheme

      // Vuetify 테마 설정
      this.$vuetify.theme.dark = this.isDarkTheme

      // HTML 루트 요소에 클래스 추가/제거
      const html = document.documentElement
      if (this.isDarkTheme) {
        html.classList.add('dark-theme')
      } else {
        html.classList.remove('dark-theme')
      }
    },
    setCurrentCar (item) {
      this.car = JSON.parse(JSON.stringify(item))
      this.showSearchResults = false
      this.setStatus()
    },
    getImageUrl (imageName) {
      return image.getUrl(imageName)
    },
    onAddPhoto () {
      this.$refs.fileInput.click()
    },
    onClickRegisterBlack () {
      this.showBlackRegisterModal = false
      this.registerBlack()
    },
    onClickReleaseBlack () {
      this.showBlackReleaseModal = false
      this.releaseBlack()
    },
    getStatus (item) {
      if (!item) return { normal: true, black: false, basement: false, newbie: false }
      const now = this.toTimestamp(this.formatYMDHM(Date.now())) + 1
      const bs = this.toTimestamp(item.black?.startDate)
      const be = this.toTimestamp(item.black?.endDate)
      const vs = this.toTimestamp(item.basement?.startDate)
      const ve = this.toTimestamp(item.basement?.endDate)
      const ns = this.toTimestamp(item.newbie?.startDate)
      const ne = this.toTimestamp(item.newbie?.endDate)

      const isBlack = bs && bs <= now && (!be || now <= be || be < bs)
      const isBasement = vs && vs <= now && (!ve || now <= ve)
      const isNewbie = ns && ns <= now && (!ne || now <= ne)
      const normal = !isBlack && !isBasement && !isNewbie
      return { normal: normal, black: isBlack, basement: isBasement, newbie: isNewbie }
    },
    toTimestamp (dateStr) {
      if (!dateStr) return null
      const parsed = new Date(dateStr.replace(/-/g, '/'))
      return parsed.getTime()
    },
    // Date 또는 ISO 문자열 → "yyyy-MM-dd HH:mm:ss"
    formatYMDHM (str) {
      if (str === null) return null
      const d = new Date(str)
      if (isNaN(d)) return ''
      const z = n => String(n).padStart(2, '0')
      return (
        `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}` +
        ` ${z(d.getHours())}:${z(d.getMinutes())}:${z(d.getSeconds())}`
      )
    },
    startEditDetail () {
      this.editableDetail = this.car.ownerDetail || ''
      this.isEditingDetail = true
    },
    cancelEditDetail () {
      this.isEditingDetail = false
    },
    async saveDetail () {
      this.car.ownerDetail = this.editableDetail
      this.isEditingDetail = false
      eventBus.$emit('showLoading')
      const result = await car.update(this.car)
      eventBus.$emit('hideLoading')
      if (result.data === 'succeed') {
        eventBus.$emit('alert', { active: true, text: '비고가 저장되었습니다' })
      } else {
        eventBus.$emit('alert', { active: true, text: '저장 실패' })
      }
    },
    onClickImage (index) {
      this.selectedImageIndex = index
      this.showImageModal = true
    },
    async onRemoveImage (index) {
      this.car.black.pictures.splice(index, 1)
      this.showImageModal = false
      eventBus.$emit('showLoading')
      const updateResponse = await car.update(this.car)
      eventBus.$emit('hideLoading')
      if (updateResponse.data === 'succeed') {
        eventBus.$emit('alert', { active: true, text: '이미지가 제거되었습니다' })
      } else {
        eventBus.$emit('alert', { active: true, text: '제거 실패' })
      }
    },
    /**
     * 파일이 선택되면 호출됩니다.
     * event.target.files 에서 첫 번째 파일을 꺼내 selectedFile에 저장합니다.
     */
    async onHandleImageFile (event) {
      const files = event.target.files
      if (!(files && files.length > 0)) return
      try {
        this.carBlackImageTarget = await this.resizeImageFile(files[0])
        await this.onProcessAddImage()
      } catch (err) {
        eventBus.$emit('alert', { active: true, text: '이미지 리사이즈 실패:' })
      }
      this.$refs.fileInput.value = ''
    },
    makeFileFormData (file) {
      const formData = new FormData()
      formData.append('sourceFile', file)
      return formData
    },
    sanitizePhone (phone) {
      if (!phone) return ''
      return phone.replace(/[-._\s]/g, '')
    },
    async onProcessAddImage () {
      if (this.carBlackImageTarget == null) return
      eventBus.$emit('showLoading')
      const { data } = await image.create(this.makeFileFormData(this.carBlackImageTarget))
      eventBus.$emit('hideLoading')
      if (this.car.black == null) { this.car.black = { startDate: '', endDate: '', reason: '', pictures: [] } }
      this.car.black.pictures.push(data.name)
      eventBus.$emit('showLoading')
      const updateResponse = await car.update(this.car)
      eventBus.$emit('hideLoading')
      if (updateResponse.data === 'succeed') {
        eventBus.$emit('alert', { active: true, text: '이미지가 등록되었습니다' })
      } else {
        eventBus.$emit('alert', { active: true, text: '등록 실패' })
      }
    },
    async registerBlack () {
      this.car.black.startDate = this.formatYMDHM(Date.now())
      eventBus.$emit('showLoading')
      const updateResponse = await car.update(this.car)
      eventBus.$emit('hideLoading')
      if (updateResponse.data === 'succeed') {
        eventBus.$emit('alert', { active: true, text: '블랙이 등록되었습니다' })
      } else {
        eventBus.$emit('alert', { active: true, text: '블랙 등록 실패' })
      }
      this.setStatus()
    },
    async releaseBlack () {
      this.car.black.endDate = this.formatYMDHM(Date.now())
      eventBus.$emit('showLoading')
      const updateResponse = await car.update(this.car)
      eventBus.$emit('hideLoading')
      if (updateResponse.data === 'succeed') {
        eventBus.$emit('alert', { active: true, text: '블랙이 해제되었습니다' })
      } else {
        eventBus.$emit('alert', { active: true, text: '블랙 해제 실패' })
      }
      this.setStatus()
    },
    formatPhoneNumber (raw) {
      if (!raw) return ''
      const cleaned = raw.replace(/[-._\s]/g, '')
      if (cleaned.length === 11 && cleaned.startsWith('01')) {
        return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`
      } else if (cleaned.length === 10) {
        if (cleaned.startsWith('02')) {
          return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`
        } else {
          return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
        }
      } else {
        return raw
      }
    },
    /**
     * 주어진 이미지 파일을 가로·세로 최대 1024px로 비율 유지하여 축소한 뒤,
     * JPEG 형식의 새로운 File 객체로 반환합니다.
     *
     * @param {File} file - 입력 이미지 파일 (예: PNG, JPEG 등)
     * @param {number} maxSize - 축소할 최대 크기 (기본값: 1024)
     * @param {number} quality - JPEG 압축 품질 (0.0 ~ 1.0, 기본값: 0.8)
     * @returns {Promise<File>} - 축소된 JPEG File 객체
     */
    async resizeImageFile (file, maxSize = 1024, quality = 0.8) {
      // 1. File → HTMLImageElement 로딩
      function loadImageFromFile (inputFile) {
        return new Promise((resolve, reject) => {
          const url = URL.createObjectURL(inputFile)
          const img = new Image()
          img.onload = () => {
            URL.revokeObjectURL(url)
            resolve(img)
          }
          img.onerror = () => {
            URL.revokeObjectURL(url)
            reject(new Error('이미지 로드 실패'))
          }
          img.src = url
        })
      }

      // 2. 원본(w, h)을 기준으로 최대 maxSize를 넘지 않도록 비율 계산
      function calcTargetSize (origW, origH, limit) {
        const ratio = Math.min(limit / origW, limit / origH, 1)
        return {
          width: Math.round(origW * ratio),
          height: Math.round(origH * ratio)
        }
      }

      // 3. HTMLImageElement → 캔버스에 그려 JPEG Blob 생성
      function imageToJpegBlob (imageEl, targetW, targetH, jpegQuality) {
        return new Promise((resolve) => {
          const canvas = document.createElement('canvas')
          canvas.width = targetW
          canvas.height = targetH
          const ctx = canvas.getContext('2d')
          ctx.drawImage(imageEl, 0, 0, targetW, targetH)
          canvas.toBlob(
            (blob) => {
              resolve(blob)
            },
            'image/jpeg',
            jpegQuality
          )
        })
      }

      // 4. 확장자를 .jpg 로 바꾼 파일명 생성
      function makeJpgName (originalName) {
        const idx = originalName.lastIndexOf('.')
        if (idx === -1) {
          return originalName + '.jpg'
        }
        return originalName.slice(0, idx) + '.jpg'
      }

      // ---- 메인 로직 시작 ----
      // (1) 이미지 로딩
      const imgEl = await loadImageFromFile(file)
      // (2) 축소할 크기 계산
      const { width: targetW, height: targetH } = calcTargetSize(
        imgEl.width,
        imgEl.height,
        maxSize
      )
      // (3) 캔버스에서 JPEG Blob 생성
      const jpegBlob = await imageToJpegBlob(imgEl, targetW, targetH, quality)
      // (4) Blob → File 변환
      const newName = makeJpgName(file.name)
      return new File([jpegBlob], newName, { type: 'image/jpeg' })
    }
  }
}
</script>

<style lang="scss" scoped>
.car-search-header {
  display: flex;
  background: #627ef8;
  height: 50px;
  width: 100%;
}
.car-search-content {
  display: flex;
  flex-direction: column; // ← 수직 정렬
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.login-form {
  width: 400px;
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.car-ui-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 전체 뷰포트 높이 */
  overflow: hidden; /* 중간 영역만 스크롤 되게 함 */
  background-color: var(--bg-color);
  width: 100%;
  //box-sizing: border-box;
}

.car-info {
  flex: 1;
  font-size: 16px;
  line-height: 1.5;
  padding: 12px;
}
.car-number {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
}
.car-owner,
.car-relation {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  font-weight: 500;
  margin-bottom: 12px;
}

.car-input {
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  z-index: 10;
  background-color: var(--border-color);
}

.input-display {
  font-size: 20px;
  text-align: center;
  padding: 10px;
  font-weight: bold;
}
.input-display-empty {
  font-size: 20px;
  color: #999999;
  text-align: center;
  padding: 10px;
  font-weight: bold;
}
.keypad {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.keypad .row {
  display: flex;
  justify-content: space-between;
}
.keypad button {
  flex: 1;
  height: 50px;
  font-size: 18px;
  margin: 2px;
  background-color: #ccc;
  border: none;
  border-radius: 4px;
  transition: background-color 0.15s;
  user-select: none;
}

.keypad button:active {
  background-color: #627ef8;
  color: white;
}

.search-result-list {
  margin-top: 8px;
  padding: 0 8px;
}

.search-result-item {
  margin-bottom: 8px;
  cursor: pointer;
  transition: box-shadow 0.2s;
}

.search-result-item:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.section-divider {
  border: none;
  border-top: 1px solid #ccc;
  margin: 12px 0;
}

.car-search-header {
  top: 0;
  flex-shrink: 0;
  display: flex;
  position: sticky;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background: #627ef8;
  height: 50px;
  width: 100%;
  color: white;
  z-index: 10;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
}

.header-icons {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  cursor: pointer;
  font-size: 24px;
  transition: color 0.2s;
}

.header-icon:hover {
  color: #ffcc00;
}

:root.dark-theme {
  --bg-color: #222;
  --text-color: #eee;
}

.dark-theme body {
  background-color: var(--bg-color);
  color: var(--text-color);
}

.car-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
}

.car-number-info {
  display: flex;
  flex-direction: column;
}

.status-text {
  color: var(--text-color);
  font-size: 12px;
}

.status-badge {
  display: flex;
  align-items: center;      // 수직 중앙 정렬
  justify-content: center;  // 수평 중앙 정렬
  padding: 8px 14px;
  border-radius: 12px;
  width: 80px;
  text-align: center;
  font-weight: bold;
  color: white;
  font-size: 16px;
  white-space: nowrap;
  border: 2px solid #ffffff;
}

/* 색상 클래스 정의 */
.status-badge.black {
  background-color: #333;
}

.status-badge.orange {
  background-color: #f9a825;
}

.status-badge.blue {
  background-color: #1976d2;
}

.car-status {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  padding: 8px;
}

.car-status-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.status-right {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
}

.status-label {
  font-weight: bold;
  font-size: 16px;
  color: #444;
}

.status-period,
.status-note {
  font-size: 14px;
  color: #666;
  margin-left: 4px;
  line-height: 1.6;
}

.image-upload-section {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.upload-thumbnail {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.upload-button {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  color: #555;
  cursor: pointer;
  border: 1px dashed #aaa;
  transition: background-color 0.2s ease;
}

.upload-button:hover {
  background-color: #d5d5d5;
}

.photo-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.photo-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap; /* 혹은 nowrap: 넘칠 경우 스크롤로 처리할 경우 */
  gap: 8px;
  align-items: center;
}

.photo-thumb {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.photo-add {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background-color: #e0e0e0;
  font-size: 28px;
  font-weight: bold;
  color: #555;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #aaa;
  cursor: pointer;
}

.image-modal-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #00000077; // 전체 배경 어둡게
}

.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #00000077;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.image-modal-content {
  max-width: 100vw;
  max-height: 100vh;
  object-fit: contain;
}

.photo-item {
  position: relative;
}

.image-modal-header {
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  z-index: 2;
}

.modal-delete-btn {
  background-color: #e53935;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
}

.modal-close-btn {
  background-color: #627ef8;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-box {
  background-color: white;
  border-radius: 12px;
  padding: 24px 32px;
  min-width: 300px;
  max-width: 80%;
  text-align: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.modal-message {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 24px;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.modal-cancel-btn,
.modal-confirm-btn {
  flex: 1;
  font-size: 16px;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
}

.modal-cancel-btn {
  background-color: #cccccc;
  color: #333;
}

.modal-confirm-btn {
  background-color: #627ef8;
  color: white;
}

.black-status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
}

.black-status-text {
  font-size: 16px;
  white-space: nowrap;
}

.black-status-buttons {
  display: flex;
  gap: 8px;
}

.status-card {
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 12px 16px 8px 16px;
  margin-bottom: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #1f2531;
}

.car-scrollable-content {
  flex-grow: 1;
  overflow-y: auto;
  padding: 12px 16px;
  background-color: var(--bg-color);
}

.result-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background-color: var(--card-bg);
  font-weight: bold;
}

.result-status-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.result-status {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 14px;
  color: white;
  min-width: 60px;
  text-align: center;
  font-weight: bold;
}

.result-car-number {
  font-size: 18px;
}

/* ✅ 모바일 대응 */
@media (max-width: 600px) {
  .result-car-number {
    font-size: 20px;
  }

  .result-status {
    font-size: 16px;
  }

  .result-card {
    padding: 14px;
  }
}

</style>
